export default [
  // 领取课程或者票券
  {
    path: '/note',
    name: 'note',
    component: _ => import("@/pages/notes/index.vue"),
    meta: {
      title: '笔记'
    },
  },
  {
    path: '/note/study',
    name: 'note-study',
    component: _ => import("@/pages/notes/study.vue"),
    meta: {
      title: '笔记'
    },
  },
  {
    path: '/note/search',
    name: 'note-search',
    component: _ => import("@/pages/notes/search.vue"),
    meta: {
      title: '笔记'
    },
  },
]